// extracted by mini-css-extract-plugin
export var actionIcon = "_lz-0";